import {defineStore} from 'pinia'
import {reactive} from 'vue'
import api from '@/services/api'

export const useItemIdsStore = defineStore('itemIds', () => {
    const ids = reactive({})
    const loadingPromises = reactive({})
    
    async function get({tableName}) {
        if (ids[tableName]) return ids[tableName]
        if (loadingPromises[tableName]) return loadingPromises[tableName]
        
        const promise = (async () => {
            try {
                const data = await api.get('api/component/' + tableName + '/id')
                const fetchedIds = data.data.values
                
                ids[tableName] = fetchedIds
                loadingPromises[tableName] = null
                
                return fetchedIds
            } catch (err) {
                loadingPromises[tableName] = null
                throw err
            }
        })()
        
        loadingPromises[tableName] = promise
        return promise
    }
    
    return {
        ids,
        loadingPromises,
        get
    }
})